import { render } from "./CompanyList-Owners.vue?vue&type=template&id=4a42ffcb&ts=true"
import script from "./CompanyList-Owners.vue?vue&type=script&lang=ts"
export * from "./CompanyList-Owners.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__